import React from 'react';
import {HashLink as Link} from "react-router-hash-link";
import BBExternalLink from "../../components/customBreachBits/accents/BBExternalLink";
import {useDispatch, useSelector} from "react-redux";
import {
    bbFindSubportfolioWithinPortfolio,
    bbGetSortedArrayOfSubportfoliosFromPortfolioObject
} from "../../util/bbHelpers";
import {setSubportfolioInView} from "../../actions";
import BBIconQuestionHandRequest from "../../assets/bbCustomIcons/BBIconQuestionHandRequest";
// import LaunchTourIconButton from "./LaunchTourIconButton";



export const BRfPTourInsightsPro = {
        url: `/board/BreachRisk/Portfolio/Insights`,
        type: `tutorial`,
        user: {
            first_login: true,
            // first_time_on_page: true,
            // manager: true,
        },
        entity: {
            // verified_ownership: false,
            // subscription: "Portfolio",
            // subLevel: ["pro"],
            hasScores: null,
        },
        openingModal: {
            icon: null,
            heading: "Tour Portfolio Insights?",
            description: <div className={"text-center"}>
                <h3>
                    Find the highest risks associated with companies and groups across your portfolio, compare scores,
                    and determine which companies or group of companies need your attention.
                </h3>
            </div>
        },
        tourSteps: {
            3: {
                step: 3,
                title: "Take A Closer Look At A Portfolio Group",
                placement: "top",
                content: <>
                    <p><em>If you utilize the new portfolio groups feature, this is where you can choose which group to take a closer look at.
                    </em></p>
                    <p>Select what you'd like to compare. Look across all companies by selecting "Summary of All Companies" for a high level look at all your groups.
                    Or choose a single group to get a comparison across the companies in that group.</p>
                    <small><BBExternalLink href={"https://support.breachbits.com/knowledge/make-subportfolio-group"}>Learn how to make subportfolio groups.</BBExternalLink></small>
                </>,
                scrollToElement: null,
                element: document.getElementsByClassName("tourSelectPortfolioElement"),
                anchorEl: "#tourSelectPortfolioGroup",
                // action: stepOneAction,
                last: false,
            },
            2: {
                step: 2,
                title: "Portfolio Groups or Group Focus",
                placement: "bottom-start",
                content: <>
                    <p>Whether you're comparing across groups or looking at an individual group, begin to find the details about how companies in your portfolio are performing and what risks they're facing.</p>
                </>,
                anchorEl: '#tourSelectedFocus',
                scrollToElement: null,
                element: document.getElementsByClassName("tourSelectedFocusElement"),
                // action: stepTwoAction,
                // value: arrayOfSubportfolios &&arrayOfSubportfolios[0]&& arrayOfSubportfolios[0].id,
                last: false,
            },
            1: {
                step: 1,
                title: "Risk Chart: Company Top Risks",
                placement: "left",
                content: <>
                    <p>Take a look at the highest risk threat from each of the companies in your portfolio. Hover over the chart to see more information about who has the risk and what the risk is.</p>
                </>,
                scrollToElement: "#tourIdAllCompanies",
                anchorEl: "#tourAllCompaniesRow",
                // element: document.getElementsByClassName("tourDangerLevelCol"),
                last: false,
                // element: document.getElementById(),
            },
            4: {
                step: 4,
                title: "All Companies Ranked",
                placement: "bottom",
                content: <>
                    <p>
                        Get a different view to compare companies across your portfolio with this table.
                    </p>
                    <h3>Be sure to use the 'COLUMNS' selector to see the information that matters to you, like the next time a cycle will run ("Next Scoring") or where the company has a BreachRisk&trade; subscription ("Active Subscription").</h3>
                </>,
                anchorEl: "#tourCompaniesRanked",
                // anchorEl: "#tourPortfolioEntitiesTable",
                scrollToElement: "#tourCompaniesRanked",
                // element: document.getElementsByClassName("tourThreatCol"),
                last: false,
            },
            5: {
                step: 5,
                placement: "left",
                title: "Risk Distribution",
                content: <>
                    <p>See what the relative risks are across your portfolio. This pie chart uses risk categories to help you see what percentage of your portfolio needs attention.</p>
                </>,
                anchorEl: "#tourRiskDistributionPieChart",
                scrollToElement: "#tourCompaniesRanked",
                // element: document.getElementsByClassName("tourThreatCol"),
                last: false,
            },
            6: {
                step: 6,
                title: "Collateral Risk Indicators",
                content:<>
                    <p>
                        See rankings and review various indicators from all companies in your portfolio to get a sense of what companies are like. Who has the largest cyberspace? The most threats? The most people associated with the company?
                    </p>
                    <p>
                        <em>Collateral Risks don't directly influence Risk Scores, but can be an indication of other aspects of risk and security.</em>
                    </p>
                </>,
                anchorEl: "#tourCollateralRisk",
                scrollToElement: null,
                last: false,
            },
            7: {
                step: 7,
                title: "View Individual Companies' Scores",
                content:<>
                    <p>
                        To take a look at individual companies, visit the Scores Page.
                    </p>
                    <p>
                    </p>
                </>,
                anchorEl: "#tourStepBRPortfolioInsightsScores",
                element: document.getElementsByClassName("tourStepBRPortfolioInsightsScores"),
                scrollToElement: null,
                last: true,
            },
        },
        style: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'white',
            boxShadow: 24,
            p: 4,
        }
    }

